export const GeneralConstants = {
    IGORAI_SAAS_ENV: "saas",
    IGORAI_USERNAME: "IGOR^AI",
    DYNAMIC_DELIVERY_14_DAYS_FREE_TRIAL: 14
} as const;